export const GOOGLE_API_KEY = 'AIzaSyDkqfIV7C-6y9qooHfRUuEmns4VtKPJhLA';

export function buildStreetViewUrl(location, { width = 900, height = 500 } = {}) {
  const loc = typeof location === 'object'
    ? `${location.lat},${location.lng}`
    : encodeURIComponent(location);
  return `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${loc}&key=${GOOGLE_API_KEY}&return_error_code=true&fov=90&pitch=5&source=outdoor`;
}

export function loadGoogleMaps() {
  if (window.google?.maps?.places) return Promise.resolve();
  if (window.__googleMapsPromise) return window.__googleMapsPromise;
  window.__googleMapsPromise = new Promise((resolve, reject) => {
    window.__googleMapsReady = resolve;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places&callback=__googleMapsReady`;
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error('Google Maps failed to load'));
    document.head.appendChild(script);
  });
  return window.__googleMapsPromise;
}
